import React from "react";

export const ContactPhoneIcon = ({ className = "" }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M14.0497 6C15.0264 6.19057 15.924 6.66826 16.6277 7.37194C17.3314 8.07561 17.8091 8.97326 17.9997 9.95M14.0497 2C16.0789 2.22544 17.9713 3.13417 19.4159 4.57701C20.8606 6.01984 21.7717 7.91101 21.9997 9.94M10.2266 13.8631C9.02506 12.6615 8.07627 11.3028 7.38028 9.85323C7.32041 9.72854 7.29048 9.66619 7.26748 9.5873C7.18576 9.30695 7.24446 8.96269 7.41447 8.72526C7.46231 8.65845 7.51947 8.60129 7.63378 8.48698C7.98338 8.13737 8.15819 7.96257 8.27247 7.78679C8.70347 7.1239 8.70347 6.26932 8.27247 5.60643C8.15819 5.43065 7.98338 5.25585 7.63378 4.90624L7.43891 4.71137C6.90747 4.17993 6.64174 3.91421 6.35636 3.76987C5.7888 3.4828 5.11854 3.4828 4.55098 3.76987C4.2656 3.91421 3.99987 4.17993 3.46843 4.71137L3.3108 4.86901C2.78117 5.39863 2.51636 5.66344 2.31411 6.02348C2.08969 6.42298 1.92833 7.04347 1.9297 7.5017C1.93092 7.91464 2.01103 8.19687 2.17124 8.76131C3.03221 11.7947 4.65668 14.6571 7.04466 17.045C9.43264 19.433 12.295 21.0575 15.3284 21.9185C15.8928 22.0787 16.1751 22.1588 16.588 22.16C17.0462 22.1614 17.6667 22 18.0662 21.7756C18.4263 21.5733 18.6911 21.3085 19.2207 20.7789L19.3783 20.6213C19.9098 20.0898 20.1755 19.8241 20.3198 19.5387C20.6069 18.9712 20.6069 18.3009 20.3198 17.7333C20.1755 17.448 19.9098 17.1822 19.3783 16.6508L19.1835 16.4559C18.8339 16.1063 18.6591 15.9315 18.4833 15.8172C17.8204 15.3862 16.9658 15.3862 16.3029 15.8172C16.1271 15.9315 15.9523 16.1063 15.6027 16.4559C15.4884 16.5702 15.4313 16.6274 15.3644 16.6752C15.127 16.8453 14.7828 16.904 14.5024 16.8222C14.4235 16.7992 14.3612 16.7693 14.2365 16.7094C12.7869 16.0134 11.4282 15.0646 10.2266 13.8631Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ContactEmailIcon = ({ className = "" }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M3 4.25C1.90065 4.25 1 5.15065 1 6.25V17.75C1 18.8494 1.90065 19.75 3 19.75H21C22.0994 19.75 23 18.8494 23 17.75V6.25C23 5.15065 22.0994 4.25 21 4.25H3ZM3.37305 5.25H20.627L12.6709 13.4004C12.332 13.7476 11.668 13.7476 11.3291 13.4004L3.37305 5.25ZM2.27441 5.55664L7.62402 11.0361L2.00146 17.9543C1.99724 14.0661 2 10.1482 2 6.25C2 5.97711 2.10426 5.73498 2.27441 5.55664ZM21.7256 5.55664C21.8957 5.73498 22 5.97711 22 6.25C22.0159 10.1454 21.9762 14.0723 22.0037 17.9551L16.376 11.0361L21.7256 5.55664ZM8.32617 11.7559L10.6143 14.0996C11.3658 14.8695 12.6342 14.8695 13.3857 14.0996L15.6738 11.7559L21.3511 18.7412C14.822 18.7674 8.28452 18.7516 2.67115 18.7375L8.32617 11.7559Z"
      fill="currentColor"
    />
  </svg>
);

export const ContactAddressIcon = ({ className = "" }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M11.6042 23.8352C11.714 23.9451 11.858 24 12.0019 24C12.1458 24 12.2898 23.9451 12.3996 23.8352C15.2995 20.9354 18.2178 17.772 19.9214 14.2897C22.1352 9.76495 21.6387 5.85169 18.4458 2.65875C16.7313 0.94425 14.4428 0 12.0019 0C9.56102 0 7.27263 0.94425 5.55809 2.65875C2.34715 5.86969 1.85881 9.80489 4.1066 14.355C6.04226 18.2734 9.6604 21.8915 11.6042 23.8352ZM6.3536 3.45427C7.91084 1.89698 9.95637 1.11839 12.0019 1.11839C14.0475 1.11839 16.0931 1.89698 17.6503 3.45427C20.5059 6.30984 20.9183 9.69248 18.9109 13.7954C17.356 16.9737 14.6987 19.9202 12.0014 22.6409C10.0404 20.6722 6.84584 17.36 5.11521 13.8568C3.0762 9.72923 3.48129 6.32658 6.3536 3.45427ZM11.9998 13.463C14.2036 13.463 15.9965 11.6701 15.9965 9.46631C15.9965 7.26253 14.2036 5.46961 11.9998 5.46961C9.79606 5.46961 8.00313 7.26253 8.00313 9.46631C8.00313 11.6701 9.79606 13.463 11.9998 13.463ZM11.9998 6.59461C13.5833 6.59461 14.8715 7.88283 14.8715 9.46631C14.8715 11.0497 13.5833 12.338 11.9998 12.338C10.4164 12.338 9.12813 11.0498 9.12813 9.46631C9.12813 7.88283 10.4164 6.59461 11.9998 6.59461Z"
      fill="currentColor"
    />
  </svg>
);

export const ContactCheckIcon = ({ className = "" }) => (
  <svg
    className={className}
    width="9"
    height="6"
    viewBox="0 0 9 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M1 3L3.5 5.5L8 1"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CONTACT_ICONS = {
  phone: ContactPhoneIcon,
  email: ContactEmailIcon,
  address: ContactAddressIcon,
};

export const ContactInfoIcon = ({ type, className = "" }) => {
  const Icon = CONTACT_ICONS[type];
  if (!Icon) return null;
  return <Icon className={className} />;
};
